import { MessageCircle } from 'lucide-react';
import { WA_URL_FAB } from '../../lib/wa';

export const WhatsAppFab = () => (
  <a
    href={WA_URL_FAB}
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 left-6 z-50 flex items-center gap-3 bg-[#1e3a8a] hover:bg-[#1e40af] text-white px-5 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
    aria-label="Chat with Atlas on WhatsApp"
    data-testid="whatsapp-fab"
  >
    <MessageCircle className="h-5 w-5" />
    <span className="font-medium text-sm hidden sm:inline">Chat with Atlas</span>
  </a>
);
